import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	min-height: 50vh;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1.5rem;

	@media (max-width: 1000px) {
		grid-template-columns: 1fr;
		min-height: 100%;
	}
`;
